module.exports = __webpack_public_path__ + "img/logo_visor_grd.298a8d40.png";